// storybook-check-ignore
import React from 'react';

import { Link } from '@opendoor/bricks/core';
import Box from '@opendoor/bricks/core/Box';

import { OpendoorLogo, OpendoorLogoBadge } from '../OpendoorLogo';

export const LogoSection: React.FC = () => {
  return (
    <Box gridColumn="1 / 2" gridRow="1 / 2" pr="16px" display="flex" alignItems="center" zIndex="5">
      <Link
        color="warmgrey950"
        href="/"
        analyticsName="cosmos-logo-link"
        aria-label="Go to Home page"
        display={['none', null, 'flex']}
      >
        <OpendoorLogo width="96px" />
      </Link>
      <Link
        color="warmgrey950"
        href="/"
        analyticsName="cosmos-logo-link"
        aria-label="Go to Home page"
        display={['flex', null, 'none']}
      >
        <OpendoorLogoBadge />
      </Link>
    </Box>
  );
};
